"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialBobGroupIntValues = exports.BOB_GROUP_LOGO = exports.BOB_GROUP = void 0;
exports.BOB_GROUP = "BOB_GROUP";
exports.BOB_GROUP_LOGO = "https://api-docs.bob.co.za/logo_black.png";
exports.initialBobGroupIntValues = { type: exports.BOB_GROUP, data: { api_key: "" } };
